import { createContext, useContext } from 'react';

export const EnterpriseContext = createContext(null);
export const useEnterprise = () => useContext(EnterpriseContext);
